import { Issue } from "generated-graphql/graphql";
import { InventoryLink } from "./InventoryLink";

export const ProductInventoryLink = ({
  tenantId,
  reportId,
  facilityId,
  productId,
  productName: productName,
  issues,
  reportingYear,
}: {
  tenantId: string;
  reportId: string | undefined;
  facilityId: string;
  productId: string;
  productName: string;
  issues: Issue[];
  reportingYear: number;
}) => {
  const link = `/o/${tenantId}/chemicals/${
    reportId ? `reports/${reportId}` : `inventory/${facilityId}`
  }/products/${productId}${reportId ? "" : `?ry=${reportingYear}`}`;
  return (
    <InventoryLink link={link} name={productName} issueCount={issues.length} />
  );
};
